/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { Dropdown } from 'antd'
import type { MenuProps } from 'antd'
import colors from '@sportninja/common/constants/appColors'

interface RowActionsCellProps {
  items: MenuProps['items']
  onSelect: (key: string) => void
  label: string
}

const RowActionsCell = ({ items, onSelect, label }: RowActionsCellProps) => {
  'use memo'

  if (!items || items.length === 0) {
    return null
  }

  return (
    <Dropdown
      trigger={['click']}
      menu={{ items, onClick: ({ key }) => onSelect(key) }}
      // AG Grid cells clip their overflow, so a menu anchored inside the cell
      // (antd's default, and the `triggerNode.parentElement` idiom used
      // elsewhere in this app) is cut off or invisible. Portal to the body and
      // lift it above the grid's own stacking context instead.
      getPopupContainer={() => document.body}
      overlayStyle={{ zIndex: 10002 }}
    >
      <button
        type='button'
        aria-label={label}
        css={triggerStyle}
        onClick={(event) => event.stopPropagation()}
      >
        ⋯
      </button>
    </Dropdown>
  )
}

const triggerStyle = css`
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 5px;
  background: transparent;
  color: ${colors.NEUTRAL_50};
  cursor: pointer;
  font-size: 16px;
  line-height: 1;

  &:hover {
    background: ${colors.SECONDARY_200};
  }

  &:focus-visible {
    outline: 2px solid ${colors.PRIMARY};
    outline-offset: 1px;
  }
`

export default RowActionsCell
